import React from "react";
import CustomModalContainer from "../../../../components/modals/CustomModalContainer";
import Button from "../../../ui/Button";
import ModalInput from "../../../ui/ModalTextInput";

interface StepFourProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const StepFour: React.FC<StepFourProps> = ({ open, onClose, onSuccess }) => {
  if (!open) return null; // Do not render the component if it's not open

  return (
    <CustomModalContainer
      title="Reset Password"
      footer={
        <div className="flex justify-between relative bottom-0">
          <Button
            type="button"
            onClick={onClose}
            label="Use as default email"
            customStyle={{
              width: "auto",
              minWidth: "150px",
              background: "none",
              color: "#000",
            }}
          />
          <Button
            label="Send code"
            type="submit"
            customStyle={{
              width: "auto",
              minWidth: "150px",
            }}
            onClick={onSuccess}
          />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      {/* Modal Body */}
      <div className="p-6">
        <ModalInput
          label="New password"
          type="password"
          placeholder="Enter new password"
          required
        />
        <ModalInput
          label="Confirm password"
          type="password"
          placeholder="Enter confirm password"
          required
        />
      </div>
    </CustomModalContainer>
  );
};

export default StepFour;
